export default "__VITE_ASSET__CZdfp8Mn__"